import React, { useEffect, useRef, useState } from "react";
import "../assets/css/value_assembly_animation.css";

const SOURCES = [
  { label: "AI Lab", angle: -90 },
  { label: "AI platform", angle: 30 },
  { label: "Advisors", angle: 150 },
];

const CENTER = 160;

function point(angle, radius) {
  const rad = (angle * Math.PI) / 180;
  return {
    x: CENTER + radius * Math.cos(rad),
    y: CENTER + radius * Math.sin(rad),
  };
}

const ValueAssemblyAnimation = () => {
  const rootRef = useRef(null);
  const [active, setActive] = useState(false);

  useEffect(() => {
    const node = rootRef.current;
    if (!node) return undefined;
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      setActive(true);
      return undefined;
    }
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) setActive(true);
      },
      { threshold: 0.35 }
    );
    observer.observe(node);
    return () => observer.disconnect();
  }, []);

  return (
    <div
      ref={rootRef}
      className={`va ${active ? "is-active" : ""}`}
      role="img"
      aria-label="AI Lab, AI platform, and advisors converging into value"
    >
      <div className="va__glow" />
      <span className="va__halo" />
      <span className="va__halo va__halo--late" />
      <div className="va__core">Value</div>
      <div className="va__rotor">
        <svg className="va__svg" viewBox="0 0 320 320" aria-hidden="true">
          {SOURCES.map((source) => {
            const outer = point(source.angle, 118);
            const inner = point(source.angle, 68);
            const path = `M ${outer.x} ${outer.y} L ${inner.x} ${inner.y}`;
            return (
              <g key={source.label}>
                <line
                  x1={outer.x}
                  y1={outer.y}
                  x2={inner.x}
                  y2={inner.y}
                  className="va__filament"
                />
                {[0, 0.9, 1.8].map((begin) => (
                  <circle key={begin} r="4" className="va__particle">
                    <animateMotion
                      dur="2.6s"
                      begin={`${begin}s`}
                      repeatCount="indefinite"
                      path={path}
                    />
                  </circle>
                ))}
              </g>
            );
          })}
        </svg>
        {SOURCES.map((source) => (
          <div
            key={source.label}
            className="va__slot"
            style={{ "--a": `${source.angle}deg` }}
          >
            <div className="va__card">
              <span className="va__mark" />
              {source.label}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ValueAssemblyAnimation;
